"use client"

import { Alert, AlertDescription } from "@/components/ui/alert"
import { AlertCircle } from "lucide-react"

interface ErrorAlertProps {
  error: string | null
}

/**
 * Component to display error messages
 */
export function ErrorAlert({ error }: ErrorAlertProps) {
  if (!error) return null

  return (
    <Alert variant="destructive" className="flex items-center">
      <AlertCircle className="h-4 w-4 flex-shrink-0" />
      <AlertDescription className="ml-2">{error}</AlertDescription>
    </Alert>
  )
}
